import type { LinkNode } from 'data-layer';
import { getCurrentHostAndPath, isLinkOut, trackEvent, getBaseUrl } from 'utils';

type FooterClickHandler = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;

export function createFooterClickHandler(link: LinkNode): FooterClickHandler {
  return () => {
    const isSelfDomain = !isLinkOut(link.url, getBaseUrl());
    const tracking = {
      category: 'Footer',
      action: link.title,
    };

    if (!isSelfDomain) {
      tracking.category = 'Link-Out';
      tracking.action = link.url;
    }

    trackEvent(tracking.category, tracking.action, getCurrentHostAndPath());
  };
}
